import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';

import { MyTab, MyTabs } from "../../../utils/MyTabs";
import { path } from "../../../utils/routesPaths";
import DemonstrativeTab from './tabs/DemonstrativeTab';
import { removeAccents } from '../../../utils/utils';
import { TextField } from '@material-ui/core';
import MySelect from '../../../utils/MySelect';
import { AccountAPI } from '../../../../API/account';
import allActions from '../../../../actions';
import UnoButton from '../../../utils/UnoButton';
import PrintIcon from '@material-ui/icons/Print';
import CodeIcon from '@material-ui/icons/Code';
import AddIcon from '@material-ui/icons/Add';
import { checkUserIsRole, roles } from '../../../utils/user';
import XmlAssetsTab from './tabs/XmlAssetsTab';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: "12px",
        '& .ipc14-components': {
            display: 'flex',
            alignItems: 'center',
            gap: "12px",
        }
    },
});

export default function DemonstrativesScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [tabValue, setTabValue] = useState(null);

    const demonstrativeTabRef = useRef();

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push(path.administrative.demonstratives.funds)
        } else if (newValue == 1) {
            history.push(path.administrative.demonstratives.xmlAssets)
        }

    };

    //IPCA14
    const [segregation, setSegregation] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(undefined);
    const [selectedAccountIndex, setSelectedAccountIndex] = useState(undefined);
    const [clientAccounts, setClientAccounts] = useState([]);

    const handleSegregation = (event, newSegregation) => {

        // if (newSegregation != segregationOnScreen) {
        //     setSegregation(newSegregation);
        // }
        setSegregation(newSegregation);

    };

    const loadAccounts = async (clientId, segregation) => {
        const response = await AccountAPI.listClientAccountsByRegime(clientId, segregation);

        console.log("RESPONSE: ", response)

        if (response.success) {

            setClientAccounts(response.body.rows)
            setSelectedAccountIndex(0);

        } else {

            console.log("error: ", response.error)

        }
    }

    useEffect(() => {
        console.log("selectedAccountIndex: ", selectedAccountIndex);
        if (clientAccounts.length) {
            const account = clientAccounts[selectedAccountIndex];
            console.log("account: ", account);
            setSelectedAccount(account);
        }
    }, [selectedAccountIndex])


    //FIM IPC14

    //XML RPPS SP
    function openSelectXmlConfigModal() {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'configXml',
            client: clientOn.client,
        }))
    }
    //FIM XML RPPS SP

    const [searchText, setSearchText] = useState("");

    const delayedChange = (text) => {
        setTimeout(() => {
            setSearchText(text)
        }, 800)
    }

    function changeSearch(e) {

        delayedChange(removeAccents(e.target.value.toUpperCase()))
        clearTimeout(delayedChange);
    }

    //O dispatch fica na aba, que é quem tem os fundos já carregados em tela
    function doReport() {
        if (demonstrativeTabRef?.current) demonstrativeTabRef.current.doPdfReport();
    }

    useEffect(() => {
        console.log("client: ", clientOn.client)
        if (!clientOn?.client) return;
        if (!tabValue) {
            handleChangeTabValue(null, 0)
        }
        if (tabValue === 0) {
            loadAccounts(clientOn.client.id, null); //segregação consolidada
        }
    }, [tabValue])


    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Fundos" />
                        {checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor]) && <MyTab label="XML" />}

                    </MyTabs>

                </div>


                <div className={classes.rightHeader}>

                    <TextField
                        style={{ width: "170px", minWidth: "180px" }}
                        onChange={(event) => changeSearch(event)}
                        className={classes.inputSearch}
                        label="Buscar fundo..."
                        variant="outlined"
                        size="small" />

                    {

                        tabValue === 1 &&
                        <UnoButton
                            size={'small'}
                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                path: 'newXmlAsset',
                            }))}
                            type='primary'
                            startIcon={<AddIcon />}>
                            {"Adicionar fundo/título"}
                        </UnoButton>
                    }

                    {
                        tabValue === 0 &&
                        <>
                            <UnoButton
                                size={'small'}
                                onClick={() => doReport()}
                                type='primary'
                                startIcon={<PrintIcon />}>
                                {"Gerar relatório"}
                            </UnoButton>
                            {clientOn?.client?.uf === "SP" && checkUserIsRole(currentUser, [roles.superadmin]) &&
                                <UnoButton
                                    style={{ marginRight: '16px' }}
                                    size={'small'}
                                    onClick={() => openSelectXmlConfigModal()}
                                    type='success'
                                    startIcon={<CodeIcon />}>
                                    {"Gerar XML"}
                                </UnoButton>}
                        </>
                    }
                </div>


            </div>
            <Switch className={classes.switch}>
                <Route path={path.administrative.demonstratives.funds}>
                    <DemonstrativeTab ref={demonstrativeTabRef} searchText={searchText} />
                </Route>
                <Route path={path.administrative.demonstratives.xmlAssets}>
                    <XmlAssetsTab />
                </Route>

            </Switch>



        </div>
    );
}



